import { http } from '@packet/management/src/api/http';
import { Hash } from 'viem';
import { PaginationParams, PaginationResponse, handleBlockViewResponse, BlockViewResponse } from '.';
import { CommitmentBaseDto, TransactionBaseDto } from '@/types/commitment';

export type ITransaction = TransactionBaseDto<CommitmentBaseDto>;
export type CommitmentDetail = CommitmentBaseDto & {
  from: Array<TransactionBaseDto>;
  to: Array<TransactionBaseDto>;
};

/**
 * commitment get (POST with JSON body)
 */
export const getCommitmentById = async (commitment: string[]): Promise<CommitmentDetail[] | undefined> => {
  const res = await http().post<CommitmentDetail[], BlockViewResponse<CommitmentDetail[]>>('/api/v1/viewing/utxo/get', { commitment });
  handleBlockViewResponse(res, '/api/v1/viewing/utxo/get');
  return res.data;
};

/**
 * 获取 commitment 列表
 */
export const getCommitmentList = async (params: PaginationParams & { address: string; chain_id: number; order?: 'asc' | 'desc'; is_frozen?: boolean; is_spent?: boolean }): Promise<PaginationResponse<CommitmentDetail> | undefined> => {
  const res = await http().get<PaginationResponse<CommitmentDetail>, BlockViewResponse<PaginationResponse<CommitmentDetail>>>('/api/v1/viewing/utxo/list', params);
  handleBlockViewResponse(res, '/api/v1/viewing/utxo/list');
  return res.data;
};

/**
 * 获取 transaction 详情
 */
export const getTransactionById = async (txhash: Hash, tx_index: number): Promise<ITransaction | undefined> => {
  const res = await http().get<ITransaction, BlockViewResponse<ITransaction>>('/api/v1/viewing/transactions/get', {
    txhash,
    tx_index,
  });
  handleBlockViewResponse(res, '/api/v1/viewing/transactions/get');
  return res.data;
};

/**
 * 获取 transaction 列表
 */

interface IGetTransactionListParams extends PaginationParams {
  address: string;
  chain_id: number;
  tx_type?: number;
  asset?: string;
  begin_time?: number;
  end_time?: number;
  order?: 'asc' | 'desc';
}

export const getTransactionList = async (params: IGetTransactionListParams): Promise<PaginationResponse<ITransaction> | undefined> => {
  const res = await http().get<PaginationResponse<ITransaction>, BlockViewResponse<PaginationResponse<ITransaction>>>('/api/v1/viewing/transactions/list', params);
  handleBlockViewResponse(res, '/api/v1/viewing/transactions/list');
  return res.data;
};
